import {hideBailDiamondMilgrain} from '../../../../utils/jewelry-validation'

export const validateBailDiamondFields = (filters) => {
  const fieldNames = [
    'bail_diamond_shape',
    'bail_diamond_quality',
    'bail_diamond_setting_style'
  ]

  const fieldErrorMsgMapping = {
    'bail_diamond_shape': 'Shape of Diamonds on Bail',
    'bail_diamond_quality': 'Quality of Diamonds on Bail',
    'bail_diamond_setting_style': 'Setting Style of Diamonds on Bail',
    'bail_diamond_milgrain': 'Milgrain Bail'
  }

  // if bail diamond milgrain is not hidden, then it should be validated
  if (!hideBailDiamondMilgrain(filters)) {
    fieldNames.push('bail_diamond_milgrain')
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/bail-diamond-fields/index.js